export enum Language {
  ENGLISH = 'english',

  GERMAN = 'german',

  POLISH = 'polish',

  ROMANIAN = 'romanian',
}
